module.exports = __webpack_public_path__ + "img/app-window.3c4642c7.jpeg";